import './Footer.css'; // Your CSS file
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          {/* Column 1 */}
          <div className="footer-col">
            <h4>company</h4>
            <p className='text-justify text-white'>
              Logistics Sector Skill Council, (LSC) a not for profit organization registered under Sec.8 of Indian Companies Act,2013 set up by Ministry of Skill Development & Entrepreneurship (MSDE) / National Skill Development Corporation (NSDC) and Confederation of Indian Industries (CII) with the aim to ensure skill trained Human Resource at entry level and up-skill the logistics workforce.
            </p>
          </div>

          {/* Column 2 */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="https://lsc-india.com" target='_blank' rel="noopener noreferrer">LSC Website</a></li>
              <li><a href="https://ocp.lsc-india.org" target='_blank' rel="noopener noreferrer">Online Certificate Programmes</a></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div className="footer-col">
            <h4>Contact Us</h4>
            <ul>
              <li><FaEnvelope /> <a href="mailto:solutions@lsc-india.com">solutions@lsc-india.com</a></li>
              <li><FaPhone /> <a href="tel:+919840098233">+91-9840098233</a></li>
              <li><FaMapMarkerAlt /> 
                <p className='text-justify text-white' style={{ display: "inline-block", marginLeft: "5px" }}>
                  No.480A , 7th Floor, Khivraj Complex II, Anna Salai, Nandanam, Chennai, Tamil Nadu - 600 035.
                </p>
              </li>
            </ul>
          </div>

          {/* Column 4 - Social Media */}
          <div className="footer-col">
            <h4>follow us</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/LSCIndiaOfficial" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
              <a href="https://x.com/LogisticsSSC" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
              <a href="https://www.instagram.com/logisticssector_skillcouncil/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://www.linkedin.com/company/logistics-sector-skill-council/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
                <a href="https://www.youtube.com/@logisticsSSC" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
     <hr></hr>
        {/* Copyright */}
        <div className="text-center mt-6 text-white">
          &copy; {currentYear} Logistics Sector Skill Council. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
